/** @jsx jsx */
import React from "react";
import { jsx } from "@emotion/core";
export const FlipFlops = React.forwardRef<
  SVGSVGElement,
  Omit<React.SVGProps<SVGSVGElement>, "css">
>((props, ref) => (
  <svg viewBox="0 0 121.5 121.5" ref={ref} {...props}>
    <style>
      {
        ".st3{fill:#fff}.st4{fill:none;stroke:#3f20ba;stroke-width:1.2;stroke-miterlimit:10}.st5{stroke-linecap:round;stroke-linejoin:round}.st5,.st6{fill:#d9cfff;stroke:#3f20ba;stroke-width:1.2;stroke-miterlimit:10}.st7{fill:#3f20ba}"
      }
    </style>
    <g id="Layer_1">
      <path
        d="M7.32 50.68c-8.75 5.05-3.59 11.74 5.14 16.77 15.53 8.97 11.82 14.04 23.55 20.81 13.39 7.73 28.46 9.02 39.43 2.68S71.2 76.87 64.48 72.99c-7.83-4.52-13.58-4.27-21.68-8.95S29.23 52.86 23.42 49.5s-11.09-1.72-16.1 1.18zM46.73 23.93c-8.75 5.05-3.59 11.74 5.14 16.77 15.53 8.97 11.82 14.04 23.55 20.81 13.39 7.73 28.46 9.02 39.43 2.68s-4.24-14.08-10.96-17.96c-7.83-4.52-13.58-4.27-21.68-8.95S68.64 26.1 62.84 22.75s-11.1-1.72-16.11 1.18z"
        className="st3"
      />
      <path
        d="M7.32 50.68c-8.75 5.05-3.59 11.74 5.14 16.77 15.53 8.97 11.82 14.04 23.55 20.81 13.39 7.73 28.46 9.02 39.43 2.68S71.2 76.87 64.48 72.99c-7.83-4.52-13.58-4.27-21.68-8.95S29.23 52.86 23.42 49.5s-11.09-1.72-16.1 1.18z"
        className="st4"
      />
      <path
        d="M32.9 59.43s12.8-1.97 19.3 1.78c8.59 4.96 7.3 12.25 7.3 12.25-4.79-2.77-10.51-4.34-18.98-2.07-12.12 3.25-18.1-4.65-18.1-4.65 0 6.3 6.21 9.74 16.02 9.74s14.39-3.19 22.4 1.43c3.31 1.91 3.97 5.19 4.09 6.75.04.5.46.88.96.88.55 0 .99-.46.96-1-.3-5.73-3.16-6.81-3.16-11.58 0-5.03-1.18-9.71-7.84-13.55-7.7-4.46-22.95.02-22.95.02z"
        className="st5"
      />
      <path
        d="M79.3 86.02c-.01 1.68-1.12 3.35-3.86 4.93C64.47 97.28 49.4 96 36.01 88.27c-11.73-6.77-8.02-11.84-23.55-20.81-5.54-3.2-9.63-7.06-9.66-10.74v5.79c.14 3.63 4.21 7.43 9.66 10.57 15.53 8.97 11.82 14.04 23.55 20.81 13.39 7.73 28.46 9.02 39.43 2.68 2.66-1.54 3.78-3.15 3.85-4.78l.01-5.77z"
        className="st6"
      />
      <g>
        <path d="M75.82 96.05l.5-3.86.5 3.86z" className="st7" />
      </g>
      <g>
        <path
          d="M3.64 59.7l11.55-6.24-11.17 6.88zM4.61 61.37l7.72-4.03-7.35 4.68zM2.71 55.77l9.88-5.27-9.5 5.92zM2.68 58.02l7.38-3.83-7.01 4.48zM6.24 62.65l11.55-6.23L6.62 63.3zM7.54 64.13l7.73-4.02-7.35 4.67zM9.18 65.42l11.54-6.23-11.17 6.88zM11.15 66.51l7.38-3.83-7.01 4.48zM31.68 85.09L41.24 80l-9.19 5.74zM33.37 86.34l7.72-4.02-7.35 4.67zM29.94 83.86l6.27-3.18-5.89 3.83zM35.18 87.53l10.89-5.85-10.51 6.5zM37.15 88.62l8.27-4.34-7.9 4.99zM39.15 89.7l11.6-6.27-11.23 6.92zM41.36 90.65l8.24-4.32-7.87 4.97zM43.5 91.65l11.94-6.46-11.57 7.11zM46.03 92.42l8.26-4.34-7.89 4.99zM48.49 93.23l11.6-6.27-11.23 6.92zM51.31 93.83l7.71-4.02-7.33 4.67zM17.07 76.28l.37-3.98.38 3.98zM15.72 75.31l.37-3.99.38 3.99zM18.42 77.29l.37-4.13.38 4.13zM19.77 78.39l.38-3.86.37 3.86zM73.24 97.5l.37-3.98.38 3.98zM71.89 98.13l.37-3.99.38 3.99zM74.59 96.81l.38-4.13.37 4.13zM69.18 99.14l.38-3.98.37 3.98zM67.83 99.53l.38-3.99.37 3.99zM66.48 99.86l.37-3.99.38 3.99zM70.53 98.68l.38-4.13.37 4.13z"
          className="st7"
        />
      </g>
      <g>
        <path
          d="M46.73 23.93c-8.75 5.05-3.59 11.74 5.14 16.77 15.53 8.97 11.82 14.04 23.55 20.81 13.39 7.73 28.46 9.02 39.43 2.68s-4.24-14.08-10.96-17.96c-7.83-4.52-13.58-4.27-21.68-8.95S68.64 26.1 62.84 22.75s-11.1-1.72-16.11 1.18z"
          className="st4"
        />
        <path
          d="M72.31 32.67s12.8-1.97 19.3 1.78c8.59 4.96 7.3 12.25 7.3 12.25-4.79-2.77-10.51-4.34-18.98-2.07-12.12 3.25-18.1-4.65-18.1-4.65 0 6.3 6.21 9.74 16.02 9.74s14.39-3.19 22.4 1.43c3.31 1.91 3.97 5.19 4.09 6.75.04.5.46.88.96.88.55 0 .99-.46.96-1-.3-5.73-3.16-6.81-3.16-11.58 0-5.03-1.18-9.71-7.84-13.55-7.7-4.45-22.95.02-22.95.02z"
          className="st5"
        />
        <path
          d="M118.71 59.26c-.01 1.68-1.12 3.35-3.86 4.93-10.97 6.33-26.04 5.05-39.43-2.68-11.73-6.77-8.02-11.84-23.55-20.81-5.53-3.19-9.63-7.05-9.66-10.73v5.79c.14 3.63 4.21 7.43 9.66 10.57C67.4 55.3 63.69 60.37 75.42 67.14c13.39 7.73 28.46 9.02 39.43 2.68 2.66-1.54 3.78-3.15 3.85-4.78l.01-5.78z"
          className="st6"
        />
        <path
          d="M43.05 32.94l11.55-6.23-11.17 6.88zM44.02 34.61l7.72-4.02-7.35 4.67zM42.12 29.02L52 23.75l-9.5 5.92zM42.09 31.27l7.39-3.83-7.02 4.48zM45.65 35.9l11.55-6.23-11.17 6.88zM46.95 37.38l7.73-4.03-7.35 4.68zM48.59 38.67l11.54-6.24-11.17 6.89zM50.56 39.76l7.39-3.83-7.02 4.48zM71.09 58.34l9.56-5.09-9.19 5.73zM72.78 59.59l7.72-4.03-7.35 4.68zM69.35 57.11l6.27-3.19-5.89 3.84zM74.59 60.77l10.89-5.85-10.51 6.5zM76.56 61.87l8.27-4.34-7.9 4.99zM78.56 62.94l11.6-6.26-11.23 6.91zM80.77 63.9l8.24-4.33-7.87 4.98zM82.91 64.89l11.94-6.46-11.57 7.11zM85.44 65.66l8.26-4.34-7.89 4.99zM87.9 66.47l11.6-6.26-11.23 6.91zM90.72 67.07l7.71-4.01-7.33 4.66zM56.48 49.52l.37-3.98.38 3.98zM55.13 48.56l.37-2.99.38 2.99zM57.83 50.53l.38-4.12.37 4.12zM59.18 51.64l.38-3.87.37 3.87zM112.65 70.75l.37-3.98.38 3.98zM111.3 71.37l.37-3.99.38 3.99zM114 70.06l.38-4.13.37 4.13zM115.35 69.3l.38-3.86.37 3.86zM108.59 72.38l.38-3.98.37 3.98zM107.24 72.78l.38-3.99.37 3.99z"
          className="st7"
        />
        <g>
          <path d="M105.89 73.1l.37-3.99.38 3.99z" className="st7" />
        </g>
        <g>
          <path d="M109.95 71.92l.37-4.12.38 4.12z" className="st7" />
        </g>
      </g>
    </g>
  </svg>
));
